import { createSlice } from '@reduxjs/toolkit';

const userDataSlice = createSlice({
  name: 'userData',
  initialState: {
    data: [],
    validationName: null
  },
  reducers: {
    info(state, action) {
      state.data = action.payload.userInfo;
    },
    validation(state, action) {
      state.validationName = action.payload.validationName;
    }
  }
});

export const userDataActions = userDataSlice.actions;

export default userDataSlice;
